import React, { createContext, useContext, useEffect, useState } from "react";
import { MainContext } from "./MainContext";

let socket = null;

export const getWebSocket = () => {
    if (!socket) {
        socket = new WebSocket(`wss://netex.sandia.site/ws`);
        socket.onopen = () => {
            console.log("Connected to WebSocket server")
        };
        socket.onclose = () => console.log("WebSocket connection closed");
        socket.onerror = (error) => console.error("WebSocket error:", error);
    }
    return socket;
};

export const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children, onMessage }) => {
    const [socket, setSocket] = useState(null);
    const {refreshData} = useContext(MainContext)

    useEffect(() => {
        const ws = getWebSocket();
        setSocket(ws);
        refreshData()

        ws.onmessage = (event) => {
            if (ws.readyState === WebSocket.OPEN) {
                if (event.data === 'refresh') {
                    refreshData();
                }
            }
        };

    }, []);

    return (
        <WebSocketContext.Provider value={socket}>
            {children}
        </WebSocketContext.Provider>
    );
};
